export const myAccountAppPaths = {
  purchase: '/purchase',
  payflowEntry: '/purchase/plans-and-pricing',
  nonprofit: '/nonprofit',
  canceledPro: '/canceled/pro',
  users: '/users',
  cancel: '/cancel',
  buyNow: '/buynow',
  buyNowThankYou: '/buynow/thank-you',
  purchaseInboxPreview: '/purchaseao/ibp',
  addSms: '/addsms',
  popupCancelFlow: '/popupcancelflow',
  upgradeDialogFullScreen: '/udfs',
  upgradeDialogContents: '/upgradedialogcontents',
  upgradeDialog: '/upgradedialog',
  upgrade: '/upgrade',
  pricing: '/pricing',
  addOns: 'add-ons',
  paymentPlan: 'payment-plan-and-discounts',
  paymentPlanSelect: '/payment-plan/select',
  paymentPlanCheckout: '/payment-plan/checkout',
  checkout: 'checkout',
  confirmation: 'confirmation',
  payflowV2Entry: 'plans-and-pricing',
} as const;

export const billingAppPaths = {
  billinginfo: '/billinginfo',
  overduebalance: '/overduebalance',
  billingactivity: '/billingactivity',
  managepaymentplan: '/managepaymentplan',
  generateprepayinvoice: '/generateprepayinvoice',
  reactivation: '/reactivation',
  moretonBay: '/moreton-bay/checkout',
  moretonBayConfirmation: '/moreton-bay/confirmation',
} as const;
